"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useShell_1 = __importDefault(require("./useShell"));
var useSettings_1 = __importDefault(require("./useSettings"));
var useFullscreen = function () {
    var shell = (0, useShell_1.default)();
    var settings = (0, useSettings_1.default)()[0];
    var _a = (0, react_1.useState)(false), fullscreen = _a[0], setFullscreen = _a[1];
    var requestFullscreen = (0, react_1.useCallback)(function () {
        if (shell.active) {
            shell.send('win-set-visibility', { fullscreen: true });
        }
        else {
            document.documentElement.requestFullscreen();
        }
    }, []);
    var exitFullscreen = (0, react_1.useCallback)(function () {
        if (shell.active) {
            shell.send('win-set-visibility', { fullscreen: false });
        }
        else {
            if (document.fullscreenElement === document.documentElement) {
                document.exitFullscreen();
            }
        }
    }, []);
    var toggleFullscreen = (0, react_1.useCallback)(function () {
        fullscreen ? exitFullscreen() : requestFullscreen();
    }, [fullscreen]);
    (0, react_1.useEffect)(function () {
        var onWindowVisibilityChanged = function (state) {
            setFullscreen(state.isFullscreen === true);
        };
        var onFullscreenChange = function () {
            setFullscreen(document.fullscreenElement === document.documentElement);
        };
        var onKeyDown = function (event) {
            var activeElement = document.activeElement;
            var inputFocused = activeElement &&
                (activeElement.tagName === 'INPUT' ||
                    activeElement.tagName === 'TEXTAREA' ||
                    activeElement.tagName === 'SELECT' ||
                    activeElement.isContentEditable);
            if (event.code === 'Escape' && settings.escExitFullscreen) {
                exitFullscreen();
            }
            if (event.code === 'KeyF' && !inputFocused) {
                toggleFullscreen();
            }
            if (event.code === 'F11' && shell.active) {
                toggleFullscreen();
            }
        };
        shell.on('win-visibility-changed', onWindowVisibilityChanged);
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('fullscreenchange', onFullscreenChange);
        return function () {
            shell.off('win-visibility-changed', onWindowVisibilityChanged);
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('fullscreenchange', onFullscreenChange);
        };
    }, [settings.escExitFullscreen, toggleFullscreen]);
    return [fullscreen, requestFullscreen, exitFullscreen, toggleFullscreen];
};
exports.default = useFullscreen;
